import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resource from './translations.json';

i18n.use(initReactI18next).init({
  resources: {
    current: { translation: resource }
  },
  lng: 'current',
  fallbackLng: 'current',
  keySeparator: true,
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
